export const getGlobal = function () {
    if (typeof window !== "undefined")
        return window;
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    throw new Error("unable to locate global object");
};
